import "./ImageCard.scss";
import { Link } from "react-router-dom";
import heart from "../../assets/icons/heart.png";
import comment from "../../assets/icons/comment.png";
import { motion } from "framer-motion";

const isAuth = localStorage.getItem("token") == null ? false : true;

const ImageCard = (props) => {
  return (
    <motion.div className="image-card" whileHover={{ scale: 1.1 }}>
      <div>
        {" "}
        <Link to={`/gallery/${props.id}`}>
          <img
            src={props.picture}
            alt={"gallery"}
            className="image-card__img"
          />
        </Link>
      </div>

      <div className="image-card__buttons">
        {isAuth && (
          <Link to={`/gallery/${props.id}/edit`} className="image-card__button">
            {" "}
            EDIT
          </Link>
        )}
        <div className="image-card__container">
          <div className="image-card__like">
            <img
              src={heart}
              alt={"heart"}
              className="image-card__heart"
              onClick={() => props.handleClick(props.id)}
            />
            <p>{Number(props.likes) ? props.likes : "0"}</p>
          </div>
          <div className="image-card__post">
            <p>{props.comments.length}</p>
            <Link to={`/gallery/${props.id}`}>
              <img
                src={comment}
                alt={"comment"}
                className="image-card__comment"
              />
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ImageCard;
